import React from 'react';
import './DisclaimerModal.css';

const DisclaimerModal = ({ open, onClose }) => {
  if (!open) return null;

  return (
    <>
      {/* Backdrop */}
      <div className="modal-backdrop" onClick={onClose} />

      {/* Modal Container */}
      <div className="modal-container">
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          {/* Header */}
          <div className="modal-header">
            <div className="modal-header-title">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="m14.5 12.5-8 8a2.119 2.119 0 0 1-3-3l8-8"></path>
                <path d="m16 16 6-6"></path>
                <path d="m8 8 6-6"></path>
                <path d="m9 7 8 8"></path>
                <path d="m21 11-8-8"></path>
              </svg>
              <h2>Legal Disclaimer & Privacy Notice</h2>
            </div>
            <button onClick={onClose} className="modal-close-btn" aria-label="Close modal">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>

          {/* Content */}
          <div className="modal-body">
            {/* Entertainment Purpose Disclaimer */}
            <div className="modal-section">
              <div className="modal-section-header">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"></path>
                  <line x1="12" y1="9" x2="12" y2="13"></line>
                  <line x1="12" y1="17" x2="12.01" y2="17"></line>
                </svg>
                <h3 className="warning-color">Entertainment Purposes Only</h3>
              </div>
              <p>
                This website (https://freeweb3.com) and all information provided herein are for entertainment and
                educational purposes only. The content, data, tools, and any information presented on this site are
                not intended to constitute financial advice, investment advice, legal advice, trading advice, or any
                other sort of professional advice.
              </p>
              <p>
                You should not treat any of the website's content as professional advice. The owner and operators of
                this website are not registered investment advisors, financial advisors, broker-dealers, or attorneys
                providing legal counsel. We make no warranties or representations about the accuracy, completeness,
                reliability, or timeliness of the content, tools, or services provided on this website.
              </p>
            </div>

            <hr className="modal-divider" />

            {/* No Warranties Under California Law */}
            <div className="modal-section">
              <div className="modal-section-header">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                </svg>
                <h3 className="error-color">No Warranties or Representations</h3>
              </div>
              <p>
                Under California law and applicable federal law, the owner and operators of this website make NO
                WARRANTIES, EXPRESS OR IMPLIED, including but not limited to warranties of merchantability, fitness
                for a particular purpose, title, or non-infringement.
              </p>
              <p>
                The information provided on this site is provided "AS IS" without warranty of any kind. Your use of
                this website and its services is at your own risk. The owner shall not be liable for any damages of
                any kind arising from the use of this website, including but not limited to direct, indirect,
                incidental, punitive, and consequential damages.
              </p>
            </div>

            <hr className="modal-divider" />

            {/* CCPA Notice */}
            <div className="modal-section">
              <div className="modal-section-header">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                </svg>
                <h3 className="info-color">California Consumer Privacy Act (CCPA) Notice</h3>
              </div>
              <p>
                <strong>We do NOT collect, store, or retain any personal information.</strong>
              </p>
              <p>
                This website does not use cookies, tracking pixels, or any other data collection mechanisms to gather
                personal information from visitors. We do not collect:
              </p>
              <ul>
                <li>Names, email addresses, or contact information</li>
                <li>IP addresses or device identifiers</li>
                <li>Browsing history or website usage data</li>
                <li>Geolocation data</li>
                <li>Any other personal or identifiable information</li>
              </ul>
              <p>
                Since we do not collect any personal information, there is no data to sell, share, or disclose to
                third parties. California residents have nothing to opt-out of because no data collection occurs.
              </p>
            </div>

            <hr className="modal-divider" />

            {/* GDPR Notice */}
            <div className="modal-section">
              <div className="modal-section-header">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                </svg>
                <h3 className="success-color">General Data Protection Regulation (GDPR) Notice</h3>
              </div>
              <p>
                <strong>We do NOT collect, process, or retain any personal data.</strong>
              </p>
              <p>
                This website fully complies with the European Union's General Data Protection Regulation (GDPR) by
                not collecting any personal data from visitors, regardless of their location. We do not:
              </p>
              <ul>
                <li>Use cookies or similar tracking technologies</li>
                <li>Collect or process personal data</li>
                <li>Transfer data to third parties</li>
                <li>Profile or target users</li>
                <li>Store any information about your visit</li>
              </ul>
              <p>
                Since no personal data is collected, rights under GDPR (such as access, rectification, erasure, and
                data portability) are not applicable as there is no data to exercise these rights upon.
              </p>
            </div>

            <hr className="modal-divider" />

            {/* Copyright Information */}
            <div className="modal-section">
              <div className="modal-section-header">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"></circle>
                  <path d="M15 9.354a4 4 0 1 0 0 5.292"></path>
                </svg>
                <h3>Copyright & Ownership</h3>
              </div>
              <p>
                © {new Date().getFullYear()} <strong>Scott Stevenson</strong>. All rights reserved.
              </p>
              <p>
                This website and its content are protected by United States and international copyright laws.
              </p>
              <p>
                <strong>Operating Entity:</strong> Web3 Legal Engineering
              </p>
              <p>
                <strong>Owned by:</strong> Global REO XVIII LLC
              </p>
            </div>

            <hr className="modal-divider" />

            {/* Last Updated */}
            <div className="modal-section">
              <p className="last-updated">
                Last Updated: {new Date().toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}
              </p>
            </div>
          </div>

          {/* Footer Button */}
          <div className="modal-footer">
            <button onClick={onClose} className="modal-footer-btn">
              I Understand
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default DisclaimerModal;
